<template>
  <basicContainer>
    <div class="announcementManage">
      <avue-crud ref="avueCrud" :data="tableData" :option="option" v-model="form" :table-loading="TABLE_LOADING"
        :page.sync="TABLE_PAGE" @search-change="SEARCH_CHANGE" @refresh-change="TABLE_REFRESH"
        @search-reset="SEARCH_RESET" @cell-click="CELL_CLICK" @selection-change="SELECTION_CHANGE"
        @sort-change="SORT_CHANGE" @size-change="SIZE_CHANGE" @current-change="CURRENT_CHANGE" :before-open="beforeOpen"
        :before-close="beforeClose" @row-update="rowUpdate" @row-save="rowSave" @row-del="rowDel">
        <template v-slot:menu="{type,size,row}">
          <el-button size="small" type="text" icon="el-icon-view" @click.stop="view(row)">查看</el-button>
        </template>
      </avue-crud>
      <el-dialog append-to-body width="80%" top="2vh" :close-on-click-modal="false" v-dialogDrag class="avue-dialog"
        :title="FORMDATA.title" :visible.sync="FORMDATA.dialogVisible" v-if="FORMDATA.dialogVisible">
        <div class="iframeMain">
          <iframe :src="queryDataUrl" frameborder="0" height="100%"></iframe>
        </div>
      </el-dialog>
    </div>
  </basicContainer>
</template>

<script>
import { dateFormat } from '@/framework/util/date.js'
import {
  getDictionary
} from '@/businessManagement/utils/jwTools.js'
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'

export default {
  name: 'XSDaliyReport',
  mixins: [crudPageMinix],
  data() {
    return {
      queryDataUrl: '',
      FORMDATA: {
        queryData: {},
        dialogVisible: false
      },
      yf: '',
      option: {
        stripe: true,
        border: true,
        page: true,
        selection: false,
        tip: false,
        align: 'left',
        menuAlign: 'center',
        searchMenuSpan: 4,
        columnBtn: false,
        refreshBtn: true,
        labelWidth: 170,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menu: true,
        menuWidth: 150,
        emptyBtn: false,
        column: [
          {
            label: '时间',
            prop: 'sxsj',
            search: true,
            hide: true,
            clearable: false,
            minWidth: 120,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            searchSpan: 5,
            searchLabelWidth: 60,
            searchValue: dateFormat(new Date(), 'yyyy-MM-dd'),
            change: ({ value }) => {
              this.yf = value
              setTimeout(() => {
                this.loadData()
              }, 0)
            }
          },
          {
            label: '姓名',
            prop: 'ygxm',
            search: true,
            hide: true,
            searchLabelWidth: 60,
            searchSpan: 5,
            minWidth: 120
          },
          {
            label: '一级部门',
            prop: 'yjbm',
            search: true,
            hide: true,
            searchLabelWidth: 75,
            type: 'select',
            searchSpan: 5,
            props: {
              label: 'name',
              value: 'id'
            },
            change: ({ value }) => {
              if (this.$refs.avueCrud && this.$refs.avueCrud.searchForm) {
                this.$set(this.$refs.avueCrud.searchForm, 'ejbm', '')
              }
              if (value) {
                this.getYjbm('ejbm', value)
              } else {
                if (this.$refs.avueCrud && this.$refs.avueCrud.DIC) {
                  this.$set(this.$refs.avueCrud.DIC, 'ejbm', [])
                }
                this.$set(
                  this.option.column[
                  this.findArray(this.option.column, 'ejbm', 'prop')
                  ],
                  'dicData',
                  []
                )
              }
            }
          },
          {
            label: '二级部门',
            prop: 'ejbm',
            searchLabelWidth: 75,
            search: true,
            hide: true,
            type: 'select',
            searchSpan: 5,
            dicData: [],
            props: {
              label: 'name',
              value: 'id'
            }
          },
          {
            label: '填写日期',
            prop: 'txrq',
            minWidth: 120
          },
          {
            label: '姓名',
            prop: 'xm',
            minWidth: 120
          },

          {
            label: '所属部门',
            prop: 'orgname',
            minWidth: 120
          },
          {
            label: '拜访用户数',
            prop: 'bfkhsl',
            minWidth: 120
          },
          {
            label: '达成目标数量',
            prop: 'dcmbsl',
            minWidth: 120
          },
          {
            label: '次日拜访计划',
            prop: 'crbfjh',
            minWidth: 120
          }
        ]
      },
      form: {},
      tableData: []
    }
  },

  mounted() {
    this.loadData()
    this.getYjbm('yjbm', '1')
  },
  methods: {
    getYjbm(name, value) {
      this.$http.post('/org/list', {
        entity: {
          parentPermissionSubjectId: value,
          status: '1'
        }
      }, {
        params: {
          downwardRecursive: false
        }
      }).then(res => {
        if (name == 'yjbm') {
          res.data = res.data.filter(item => {
            return item.name == '北区管理中心' || item.name == '南区管理中心'
          })
        }
        this.$set(
          this.option.column[
          this.findArray(this.option.column, name, 'prop')
          ],
          'dicData',
          res.data
        )
      })
    },
    loadData(
      TABLE_PAGE = this.TABLE_PAGE,
      QUERY_CONDITIONS = this.QUERY_CONDITIONS,
      TABLE_ORDER = this.TABLE_ORDER,
      done,
    ) {
      this.TABLE_LOADING = true // 表格转圈
      this.QUERY_CONDITIONS.sxsj = this.yf || this.option.column[this.findArray(this.option.column, 'sxsj', 'prop')].searchValue
      this.$http
        .post('/SalesManagerDaily/queryAll',
          QUERY_CONDITIONS
          , {
            params: {
              pageNum: TABLE_PAGE.currentPage,
              pageSize: TABLE_PAGE.pageSize
            }
          })
        .then((response) => {
          this.RELOAD_CRUD(response.data.records)
          this.TABLE_PAGE.total =
            response.data.total || response.data.records.length
          this.SELECT_LIST = []
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
        .finally(() => {
          this.TABLE_LOADING = false // 表格转圈
          typeof done === 'function' && done()
        })
    },
    view(row) {
      this.FORMDATA.dialogVisible = true
      this.FORMDATA.title = '日报'
      this.FORMDATA.queryData = 'businessKey' + '=' + row.id + '&' + 'processInstanceId' + '=' + row.processInstanceId + '&' + 'pageKey' + '=' + 'VIEW' + '&' + 'isHiddenBtn' + '=' + '1'
      this.queryDataUrl = '/#/applyViewForm?' + this.FORMDATA.queryData
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeMain {
  height: 70vh;
}
.khgz {
  list-style: none;
  padding-left: 0;
  font-size: 12px;
  font-family: SourceHanSansSC-regular;
  letter-spacing: 1px;
}
.el-card {
  border-left: 5px solid #5a9bf5 !important;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
}
:deep(.theme-longyun .avue-contail, .theme-longyun .avue-main) {
  background-color: white !important;
}
</style>
